import request from '@/utils/request';

// B-8：列表响应为 { list, total, page, pageSize }，支持服务端分页与搜索
export function getUsers(params?: { page?: number; pageSize?: number; search?: string; tenantId?: string }) {
  return request.get('/user', { params });
}

export function getUser(id: string) {
  return request.get(`/user/${id}`);
}

export function createUser(data: { username: string; email: string; password: string; tenantId?: string; roleCodes?: string[] }) {
  return request.post('/user', data);
}

export function updateUser(id: string, data: Record<string, unknown>) {
  return request.put(`/user/${id}`, data);
}

export function deleteUser(id: string) {
  return request.delete(`/user/${id}`);
}

export function getProfile() {
  return request.get('/user/profile');
}

export function updateProfile(data: { username?: string; email?: string; avatar?: string }) {
  return request.put('/user/profile', data);
}
